import { PossibleFilterOperationsType } from 'src/modals/storageFilters/types'
import * as types from '../types'
import { IListItem } from 'src/hooks/useStorageObjects'
import { IStorageFilterRule } from 'src/modals/storageFilters/components/FilterField'

export interface IObjectsValue {
  createdAt: string
  fieldSchemeId: number
  floatValue: number | number
  id: number
  index: number
  integerValue: number | null
  objectId: number
  relationshipIdValue: number | null
  scheme: types.ISchema
  textValue: string
  updatedAt: string | null
}

///DELETE TYPES

export interface IObjectFilter {
  logic?: string
  conditions?: IObjectFilterCondition[]
  relationship?: string
  negation?: boolean
}

export interface IObjectFilterCondition {
  field?: string
  value?: string | string[] | IListItem
  id?: number
  text?: string
  operation?: PossibleFilterOperationsType
  negation?: boolean
  insensitive?: boolean
  info?: { primary?: string; icon?: string }

  conditions?: IObjectFilterCondition[] | IObjectFilterCondition
  logic?: string
  relationship?: string
}

export enum EObjectSorting {
  desc = 'desc',
  asc = 'asc',
}

export interface IObjectSorting {
  [key: string]: `${EObjectSorting}`
}

export interface IGetObjectsParams {
  schemeName: string
  cursor?: string
  perPage?: number
  parentObjectUniqId?: string | null
  filters?: IStorageFilterRule | null
  search?: string
  sort?: IObjectSorting | null
  smartListId?: string | number
  hasHidden?: boolean
  selectedFields?: string[]
}

export enum ObjectAllowedActions {
  show = 'show',
  update = 'update',
  destroy = 'destroy',
}
export interface IGetObjectsData {
  createdAt: string
  isDeleted: boolean
  objectSchemeId: number
  objectSchemeIdentifier: string

  parentObject?: {
    icon: string | null
    objectSchemeIdentifier: string
    parentObjectUniqId: string
    primary: string | null
    secondary: string | null
    uniqId: string
  }
  projectId: number
  uniqId: string
  updatedAt: string
  primary?: string
  secondary?: string
  icon?: string
  values: IProjectSchemeObjectFormValues
  allowedActions: `${ObjectAllowedActions}`[]
}

export type IPostDeleteAllObjectsData = Pick<
  IGetObjectsParams,
  'filters' | 'smartListId' | 'search' | 'schemeName'
>

export interface IGetObjectsShortData {
  id: number
  identifier: string
  title: string
  children: null
  primaryFieldSchemeId: number
  secondaryFieldSchemeId: number
  iconFieldSchemeId: number
}
export interface IObjectValuesRelation {
  uniqId: string
  primary?: string
  secondary?: string
  icon?: string
  objectSchemeIdentifier?: string
  parentObjectUniqId?: string
}
export interface IProjectSchemeObjectFormValues {
  [key: string]: string
}

export interface IGetObjectsByIdParams {
  uniqId: string
  schemeName: string
  // The caller renders its own "access denied" state for HTTP 403
  skipForbiddenToast?: boolean
}

export enum EDeleteObjectAction {
  DELETE = 'delete',
  VALIDATE_DELETE = 'validate_delete',
}

export interface IDeleteObjectByIdParams {
  uniqIds: string[]
  schemeName: string
  action?: EDeleteObjectAction
}

export interface IDeleteValidationObjectByIdData {
  message?: string
  type: 'warning' | 'error' | 'confirmation'
  blockedObjects?: Omit<IListItem, 'parentObject'> & {
    parentObjectSchemeIdentifier?: string
    parentObjectUniqId?: string
  }
  object?: Omit<IListItem, 'parentObject'> & {
    parentObjectSchemeIdentifier?: string
    parentObjectUniqId?: string
  }
}

export interface IPutObjectsParams {
  uniqId: string
  schemeName: string
  data: {
    parentObjectUniqId?: string
    fields: IProjectSchemeObjectFormValues
  }
}

export interface IPostObjectsParams {
  schemeName: string
  data: {
    parentObjectUniqId?: string
    fields: IProjectSchemeObjectFormValues
  }
}

export interface IObjectValidateErrors {
  errors: { [identifier: string]: string[] }
  message: string
}

export interface IGetObjectDataByNumber {
  communicationType?: string
  searchValues: string[]
}
